import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment, envtemplate } from 'src/environments/environment';

import { AuthenticationService } from './auth/_service/auth.service';
import { User } from './auth//_model/User';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public envtemplate = envtemplate;
  title = 'gs-nayeeri-multicotizador-frontend';
  currentUser: User;
  
  constructor(
    private router: Router,private authenticationService: AuthenticationService
    ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    }

    logout() {
      this.authenticationService.logout();
      this.router.navigate(['/login']);
      }
}
